import { render } from "./SaveEducation.vue?vue&type=template&id=efc80ed2"
import script from "./SaveEducation.vue?vue&type=script&lang=js"
export * from "./SaveEducation.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/hrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__